import { COMPENSATION_OTHER_ID } from '@/modules/surveys/configs/onboarding/compensation-config'
import { COMPENSATION_COLLECTIONS_PERCENTAGE_ID } from '@/modules/surveys/configs/onboarding/compensation-config'
import { COMPENSATION_ACADEMIC_HYBRID_ID } from '@/modules/surveys/configs/onboarding/compensation-config'
import { formatDollar } from '@/utils/currency-formatters'
import { COMPENSATION_EQUAL_SHARES_ID } from '@/modules/surveys/configs/onboarding/compensation-config'
import {
  COMPENSATION_HOURLY_ID,
  COMPENSATION_NET_INCOME_ID,
  COMPENSATION_PRODUCTIVITY_WRVU_ID,
} from '@/modules/surveys/configs/onboarding/compensation-config'
import { SalaryType, SurveySubmissionType } from '@/lib/generated/graphql-types'
import { COMPENSATION_SALARY_ID } from '@/modules/surveys/configs/onboarding/compensation-config'
import { formatAbbreviatedDollar } from '@/utils/currency-formatters'
import { isSalarySubmission } from './utils'

interface SalaryCompDescriptionProps {
  salary: SalaryType | SurveySubmissionType
  className?: string
  amountClassName?: string
}

export function SalaryCompDescription({
  salary,
  className,
  amountClassName,
}: SalaryCompDescriptionProps) {
  if (isSalarySubmission(salary)) {
    return null
  }
  const { compModel } = salary
  if (compModel === COMPENSATION_SALARY_ID) {
    return (
      <span className={className}>
        Salary
        {salary.baseSalary ? (
          <span className="ml-1">
            (
            <span className={amountClassName}>
              {formatAbbreviatedDollar(salary.baseSalary)}
            </span>
            )
          </span>
        ) : (
          ''
        )}
      </span>
    )
  }
  if (compModel === COMPENSATION_HOURLY_ID) {
    return (
      <span className={className}>
        Hourly
        {salary.basePayPerHour ? (
          <span className="ml-1">
            (
            <span className={amountClassName}>
              {formatDollar(salary.basePayPerHour)}
            </span>
            /hr)
          </span>
        ) : (
          ''
        )}
      </span>
    )
  }
  if (compModel === COMPENSATION_PRODUCTIVITY_WRVU_ID) {
    return (
      <span className={className}>
        Productivity
        {salary.wrvuRate &&
        salary.wrvuRate > 0 &&
        salary.compTargetWrvu &&
        salary.compTargetWrvu > 0 ? (
          <span className="ml-1">
            (
            <span className={amountClassName}>
              ${Math.round(salary.wrvuRate)}
            </span>
            /wRVU)
          </span>
        ) : (
          ''
        )}
      </span>
    )
  }
  if (compModel === COMPENSATION_NET_INCOME_ID) {
    return <span className={className}>Net Income</span>
  }
  if (compModel === COMPENSATION_EQUAL_SHARES_ID) {
    return <span className={className}>Equal Shares</span>
  }
  if (compModel === COMPENSATION_ACADEMIC_HYBRID_ID) {
    return <span className={className}>Academic Hybrid</span>
  }
  if (compModel === COMPENSATION_COLLECTIONS_PERCENTAGE_ID) {
    return (
      <span className={className}>
        Net Collections
        {salary.collectionsPct ? (
          <span className="ml-1">
            (<span className={amountClassName}>{salary.collectionsPct}</span>%)
          </span>
        ) : (
          ''
        )}
      </span>
    )
  }
  if (compModel === COMPENSATION_OTHER_ID) {
    return <span className={className}>Other</span>
  }
  return <span className={className}>Salary</span>
}
